import * as React from 'react';
import LinearProgress from '@mui/material/LinearProgress';

export function ProgressBar({ themeColor }) {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((stateProgress) => {
        if (stateProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 15;

        return Math.min(stateProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <LinearProgress
      variant="determinate"
      value={progress}
      sx={{
        backgroundColor: 'transparent',
        '& .MuiLinearProgress-bar': {
          backgroundColor: themeColor ?? 'black',
        },
      }}
    />
  );
}
